module.exports = __webpack_public_path__ + "img/taiwan.ed610aee.svg";